









































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { DxValidationGroup } from 'devextreme-vue';

import DButton from '@/components/DButton/button.vue';
import DTextbox from '@/components/DTextbox/textbox.vue';
import DSwitch from '@/components/DSwitch/switch.vue';

import _ from 'lodash';
import DxPopup from 'devextreme-vue/popup';
import TableGrid from "@/components/TableGrid/grid.vue";
import AuthService from "@/services/auth_service";
import ShareService from "@/services/share-service";
import ElementTabs from "@/components/ElTabs/tabs.vue";
import DxSelectBox from "devextreme-vue/select-box";
import {DxCheckBox} from "devextreme-vue/check-box";
import YearService from "@/services/years-service";
import CutService from "@/services/cut-service";
import dicts_cache_service from "@/services/dicts_cache_service";
import DxTagBox from "devextreme-vue/tag-box";
import {AcceptData, AcceptLogData, CutType, EcoFilialSelectionType} from "@/services/models-service";
import AcceptBlock from "./components/accept.vue";
import AcceptLogBlock from "./components/accept-log.vue";
import EmailBlock from "./components/email.vue";
import TemplateBlock from "./components/template.vue";
import {type_cut} from "@/constants";
import UserAccessService from '@/services/user_access_service';
import WebSocketService from '@/services/websocket_service';
import notify_service from "@/services/notify_service";
import EcoObjectsService from "@/services/eco-objects-service";

@Component({
  name: 'AcceptPopup',
  components: {
    DxPopup,
    DxValidationGroup,
    DSwitch,
    DTextbox,
    DButton,
    TableGrid,
    ElementTabs,
    DxSelectBox,
    DxCheckBox,
    DxTagBox,
    AcceptBlock,
    AcceptLogBlock,
    EmailBlock,
    TemplateBlock,
  }
})

export default class extends Vue {
  public shareService = ShareService;
  public authService = AuthService;
  public cutService = CutService;

  // Парамерты определения для оператора ТУ
  private isNodeOperator = false;

  public cut_ds: any[] = [];

  currentTab = 'main';
  tabsList: any[] = [
    {text: "Основное меню", key: 'main'},
    {text: "Лог событий", key: 'log'},
    {text: "Рассылка уведомлений", key: 'email'},
    {text: "Шаблоны уведомлений", key: 'template'},
  ];

  // Add missing properties
  public all_filials: any[] = [];
  public all_filials_tree: any = {};
  public all_facilities: any[] = [];

  public accept: AcceptData = new AcceptData();
  public ecoTree: EcoFilialSelectionType[] = [];
  public selectedFacilitiesId: number[] = [];

  public acceptLog: AcceptLogData = new AcceptLogData();
  public acceptEmail: AcceptData = new AcceptData();
  public columns: any[] = [];
  public checked_objects: any[] = [];
  public permissions: any = {};

  private ls_key: string = 'accept_popup_filters';
  private saved_filters: any = {
    year_id: null,
    year_id_log: null,
    cut_id: null,
    cut_id_log: null,
    months: null
  }

  public isLoaded: boolean = true;

  // Add missing methods
  async getFilialsTree() {
    if (!this.accept.id_year || !this.accept.id_cut) {
      return;
    }

    const year = YearService.YearList.find((y: any) => y.id === this.accept.id_year);
    const cut = this.cut_ds.find((c: any) => c.id === this.accept.id_cut);

    if (!year || !cut) {
      return;
    }

    let allowed_filials_ids = new Set();
    for (let key in UserAccessService.userAccessDS) {
      allowed_filials_ids.add(+key);
    }

    this.all_filials = [];
    this.all_filials_tree = {};
    const response = await EcoObjectsService.filial_nodes_tree_extended(cut.id_eco_version, year.name, null);

    if (response?.data) {
      const filials_tree = _.cloneDeep(response.data);
      for (let filial_uid in filials_tree) {
        const filial = filials_tree[Number(filial_uid)];
        const filial_id = `${filial.filial.id}`;
        if (!this.authService.isAdmin() && !allowed_filials_ids.has(filial.filial.id)) {
          continue;
        }

        this.all_filials_tree[filial_id] = [];
        for (let node_uid in filial.nodes) {
          const node = filial.nodes[Number(node_uid)];
          this.all_filials_tree[filial_id].push(node);
        }

        if (this.all_filials_tree[filial_id].length > 0) {
          this.all_filials.push(filial.filial);
        }
      }
    }
  }

  get mailing() {
    for (let node in this.permissions) {
      if (this.permissions[node].hasOwnProperty('accept__mailing') && this.permissions[node]['accept__mailing']) {
        return true;
      }
    }
    return false;
  }

  created() {
    this.permissions = UserAccessService.checkAccept();
  }

  async onShowing() {

    // @ts-ignore
    this.$options.sockets.onmessage = (data: any) => {

      let res = WebSocketService.handleMsg(data, 'send_email');
      if (_.isNil(res)) {
        return;
      }

      const user_id = this.authService.getUserId();

      if (res.user_id !== user_id) {
        return;
      }

      if (res.result === true) {
        notify_service.success('Успешно завершена рассылка уведомлений')
      } else {
        notify_service.error('Ошибки при рассылке уведомлений: ' + res.errors)
      }
    }

    this.isLoaded = false;

    const res = await this.cutService.get();
    if (res.data) {
      const sorted = _.sortBy(res.data, [(o) => o.number]);
      this.cut_ds = sorted;
    }

    const fill_data_routes: string[] = ['losses', 'buy', 'sale', 'transport_cost', 'transport_gain'];

    const route: any = this.$route.name;
    if (fill_data_routes.indexOf(route) !== -1 && this.shareService.share_year_id && this.shareService.share_cut_id) {
      this.accept.id_year = this.shareService.share_year_id;
      this.acceptLog.id_year = this.shareService.share_year_id;
      this.acceptEmail.id_year = this.shareService.share_year_id;
      this.accept.id_cut = this.shareService.share_cut_id;
      this.acceptLog.id_cut = this.shareService.share_cut_id;
      this.acceptEmail.id_cut = this.shareService.share_cut_id;
    }
    else {
      this.setDefault();
    }


    this.isNodeOperator = AuthService.isHeatNodeOperator();
    if (!this.mailing) {
      this.tabsList[2].hidden = true;
      this.tabsList[3].hidden = true;
      this.tabsList = [ ...this.tabsList ];
    }
    this.isLoaded = true;
  }

  setDefault() {
    const year_ds = _.cloneDeep(YearService.YearList);
    const today = new Date();
    const current_year = Number(today.getFullYear());
    const default_year = year_ds.find(y => y.name === current_year);
    if (default_year) {
      this.accept.id_year = default_year.id;
      this.acceptLog.id_year = default_year.id;
      this.acceptEmail.id_year = default_year.id;

      if (this.cut_ds && this.cut_ds.length > 0) {
        const active_cut = this.cut_ds.filter((x: CutType) => {
          return x.id_eco_version === 1 && x.id_year === default_year.id && x.type === type_cut[1].name && (x.visible_for === 'Видимый для администратора' || x.visible_for === 'Видимый для всех')
        }).sort((a: CutType, b: CutType) => {
          return b.number - a.number
        })

        if (active_cut.length > 0) {
          this.accept.id_cut = active_cut[0].id;
          this.acceptLog.id_cut = active_cut[0].id;
          this.acceptEmail.id_cut = active_cut[0].id;
        }
      }
    }
  }


  onClose() {
    this.shareService.closeAcceptPopup();
    // @ts-ignore
    delete this.$options.sockets.onmessage
  }


  empty() {
    //
  }


  @Watch('accept.id_year')
  @Watch('accept.id_cut')
  @Watch('acceptLog.id_year')
  @Watch('acceptLog.id_cut')
  saveSelected() {

    if (this.isLoaded) {
      this.saveFilters();
    }
  }

  loadFilters() {


    const saved = localStorage.getItem(this.ls_key);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        this.saved_filters = _.clone(parsed);

      } catch (e) {
        //
      }
    }
  }

  saveFilters() {
    this.saved_filters.year_id = this.accept.id_year;
    this.saved_filters.year_id_log = this.acceptLog.id_year;
    this.saved_filters.cut_id = this.accept.id_cut;
    this.saved_filters.cut_id_log = this.acceptLog.id_cut;

    localStorage.setItem(this.ls_key, JSON.stringify(this.saved_filters));
  }

  @Watch("accept.id_cut")
  async onCutChange() {
    // Fix type issues by handling the array type properly
    const prevFilial: number | null = Array.isArray(this.accept.id_filial) 
      ? (this.accept.id_filial.length > 0 ? this.accept.id_filial[0] as number : null)
      : this.accept.id_filial as number | null;
    
    // Since AcceptData doesn't have these properties, we'll use any type
    const prevNode: number | null = (this.accept as any).id_heat_node;
    const prevFacility: number | null = (this.accept as any).id_facility;
    
    await this.getFilialsTree();
    
    if (this.all_filials?.some((f: any) => f.id === prevFilial)) {
      // Fix assignment to handle array type
      this.accept.id_filial = prevFilial !== null ? [prevFilial] : null;
      if (this.all_filials_tree?.[`${prevFilial}`]?.some((n: any) => n.id === prevNode)) {
        (this.accept as any).id_heat_node = prevNode;
        if (this.all_facilities?.some((f: any) => f.id === prevFacility)) {
          (this.accept as any).id_facility = prevFacility;
        } else {
          (this.accept as any).id_facility = null;
        }
      } else {
        (this.accept as any).id_heat_node = null;
        (this.accept as any).id_facility = null;
      }
    } else {
      this.accept.id_filial = null;
      (this.accept as any).id_heat_node = null;
      (this.accept as any).id_facility = null;
    }
  }

}
